
import React from "react";
import Logo from "@/components/shared/Logo";

const AuthLogo = () => {
  return (
    <div className="text-center mb-8">
      <div className="flex items-center justify-center mb-4">
        <Logo className="justify-center" />
      </div>
      <h1 className="text-2xl font-bold text-nation-blue">Sign In</h1>
      <p className="text-gray-600 mt-2">Access the NationCard™ platform</p>
    </div>
  );
};

export default AuthLogo;
